export const DO_MORE_ACKO = 'Do more with the ACKO app'
export const GET_CHALLAN = 'Get challan notifications, RTO info or car valuation'
export const DOWNLOAD_ACKO = 'https://acko-cms.ackoassets.com/Fuel_price_QR_code_72e6ff68a7.png'
export const DOWNLOAD_IOS_APP = 'https://acko-cms.ackoassets.com/fuel_ios_app_333799de52.svg'
export const DOWNLOAD_ANDROID_APP = 'https://acko-cms.ackoassets.com/fuel_android_app_4ea4e8e1c7.svg'
export const APPSTORE_LINK = 'https://ackogi02.onelink.me/mnNt/d3aba770'
export const PLAYSTORE_LINK = 'https://ackogi01.onelink.me/j0xF/fce251b8'
